import React from "react"
import Layout from "../layouts/sample";
import {ContactSectionFormOneSpanish} from "../components/global/ContactSectionFormOneSpanish";
import Seo from "../components/Seo";


const SpanishForm = () => {
  return (
    <Layout>
      <div className="container grant-form-container">
        <ContactSectionFormOneSpanish className={"mb-md-80"}/>
      </div>
    </Layout>

  )
}

export default SpanishForm

export const Head = () => <Seo title="Formulario de aplicacion para Rootstock Grant"/>;
